module.exports = __webpack_public_path__ + "78cee25f46e7d677cd2db2fcb1ffeee9.fbx";